module.exports = __webpack_public_path__ + "static/img/img2.5c5c447f.png";